import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Alert,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  NotificationsActive as NotificationsActiveIcon,
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

const BrokerageAcknowledgmentDialog = ({
  open,
  onAcknowledge,
  brokerageMessage,
  brokerageData
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleAcknowledge = () => {
    // Store acknowledgment in localStorage
    localStorage.setItem('brokerage_acknowledged', 'true');
    onAcknowledge();
  };

  if (!brokerageMessage || !brokerageData?.is_brokerage_applied) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleAcknowledge}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: 2,
          maxWidth: isMobile ? '90vw' : '500px'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 2,
          pt: 3
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <NotificationsActiveIcon 
            color="warning" 
            sx={{ fontSize: 24 }}
          />
          <Typography variant="h6" component="div" fontWeight={600}>
            Brokerage Update
          </Typography>
        </Box>
        <IconButton
          onClick={handleAcknowledge}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 3 }}>
        <Typography 
          variant="body2" 
          sx={{ 
            lineHeight: 1.6,
            color: 'text.primary',
            mb: 2
          }}
        >
          {brokerageMessage}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={handleAcknowledge}
          variant="contained"
          color="primary"
          startIcon={<CheckCircleIcon />}
          sx={{ 
            minWidth: 120,
            fontWeight: 500
          }}
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrokerageAcknowledgmentDialog;